export default "__VITE_ASSET__BracpQQO__"